export enum PropertyDetailMenuEnum {
    overview = 11,
    propertyInformation,
    builtInformation,
    //costOfconstruction,
    amentities,
    unit,
    unitTransaction,
    propertyTransaction,
    rentalIncome,
    commercialRentalIncome,
    NearByRentalAndOccupancy
}
